import { render } from "./SidebarUserCard.vue?vue&type=template&id=e3572fb0&scoped=true"
import script from "./SidebarUserCard.vue?vue&type=script&lang=js"
export * from "./SidebarUserCard.vue?vue&type=script&lang=js"

import "./SidebarUserCard.vue?vue&type=style&index=0&id=e3572fb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3572fb0"]])

export default __exports__